import exp from "constants";
import { apiClient } from "../apiClient";

export const CHUONG_TRINH_DAO_TAO_ENDPOINT = "chuong-trinh-dao-tao";
export const chuongTrinhDaoTaoApi = {
    SelectByUser: () => apiClient.get(`${CHUONG_TRINH_DAO_TAO_ENDPOINT}/user`),
    DongBoDiem: (id_dt: number) => apiClient.patch(`diem/dong-bo-diem-ctdt/${id_dt}`),
    ReadAndValidateImportCongThucData: (payload: any) => apiClient.post(`${CHUONG_TRINH_DAO_TAO_ENDPOINT}/import/read-and-validate-import-cong-thuc`, payload),
    ImportCongThuc: (payload: any) => apiClient.post(`${CHUONG_TRINH_DAO_TAO_ENDPOINT}/import-cong-thuc`, payload),
}